module.exports = __webpack_public_path__ + "img/hyl_title3.a04f207c.png";